<style lang="less">
@import "./staff.less";
</style>

<template>
  <div class="staff">
    <div class="staff-body"
         id="staff-body">
      <el-button class="page-btn-detail"
                 type="text"
                 @click="goBack"><i class="el-icon-arrow-left el-icon--left"></i>返回</el-button>
      <div class="staff-content"
           :style="{height:height+'px'}">
        <div class="content-detail">
          <div class="content-search">
            <div class="search-btn">
              <div class="detail-btn">
                <div class="label">日期:</div>
                <div class="content"
                     id="template-id">
                  <el-radio-group v-model="timeDate"
                                  size="medium"
                                  @change="changeTimeDate">
                    <el-radio :label="1"
                              border>今日</el-radio>
                    <el-radio :label="2"
                              border>昨日</el-radio>
                    <el-radio :label="3"
                              border>其他</el-radio>
                  </el-radio-group>
                  <el-date-picker v-model="timeDateValue"
                                  type="date"
                                  placeholder="请选择日期"
                                  size="medium"
                                  :clearable="false"
                                  v-if="timeDate==3"
                                  @change="getData">
                  </el-date-picker>
                </div>
              </div>
              <div class="detail-btn">
                <div class="label">完工人:</div>
                <div class="content"
                     id="staff-id">
                  <el-radio-group v-model="staffID"
                                  size="medium"
                                  @change="getData">
                    <el-radio v-for="item in staffList"
                              :label="item.id"
                              :key="item.id"
                              border>{{item.name}}</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <el-tabs class="detail-tabs"
                       v-model="activeName"
                       type="card"
                       @tab-click="tabClick">

                <el-tab-pane label="汇总"
                             name="first">
                  <p class="detail-info">日期：{{currentDate}}&nbsp;&nbsp;&nbsp;总数量：{{currentAmount}}&nbsp;&nbsp;&nbsp;总金额：{{currentMoney}}</p>
                  <el-button class="export-btn"
                             type="primary"
                             size="mini"
                             @click="exportExcel(0)">导出<i class="el-icon-download el-icon--right"></i></el-button>
                  <el-table v-bind:class="{ isModal: isModal }"
                            :data="tableDataSummary"
                            size="small"
                            :height="height-heightTemplate-heightStaff-146"
                            :row-class-name="tableRowClassName"
                            border>
                    <el-table-column type="index"
                                     label="序号"
                                     width="60"
                                     align="center">
                    </el-table-column>
                    <el-table-column prop="date"
                                     label="日期"
                                     width="100">
                    </el-table-column>
                    <el-table-column prop="productCode"
                                     label="编码"
                                     width="100">
                    </el-table-column>
                    <el-table-column prop="productName"
                                     label="产品名称">
                    </el-table-column>
                    <el-table-column prop="amount"
                                     header-align="center"
                                     align="right"
                                     label="数量"
                                     width="204">
                    </el-table-column>
                    <el-table-column prop="price"
                                     header-align="center"
                                     align="right"
                                     label="单价">
                    </el-table-column>

                    <el-table-column prop="money"
                                     header-align="center"
                                     align="right"
                                     label="金额"
                                     width="204">
                    </el-table-column>
                  </el-table>
                  <el-pagination background
                                 layout="prev, pager, next"
                                 :page-size="pageSize"
                                 :total="totalSummary"
                                 @current-change="currentSummaryChange">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="明细"
                             name="second">
                  <p class="detail-info">日期：{{currentDate}}&nbsp;&nbsp;&nbsp;总数量：{{currentAmount}}&nbsp;&nbsp;&nbsp;总金额：{{currentMoney}}</p>
                  <el-button class="export-btn"
                             type="primary"
                             size="mini"
                             @click="exportExcel(1)">导出<i class="el-icon-download el-icon--right"></i></el-button>
                  <el-table v-bind:class="{ isModal: isModal }"
                            :data="tableDataDetail"
                            size="small"
                            :row-class-name="tableRowClassName"
                            :span-method="arraySpanMethod"
                            :height="height-heightTemplate-heightStaff-146"
                            :maxHeight="height-heightTemplate-heightStaff-146"
                            border>
                    <el-table-column type="index"
                                     label="序号"
                                     width="60"
                                     align="center">
                    </el-table-column>
                    <el-table-column prop="date"
                                     label="日期"
                                     width="140">
                    </el-table-column>
                    <el-table-column prop="staff"
                                     label="完工人">
                    </el-table-column>
                    <el-table-column prop="productCode"
                                     label="编码"
                                     width="100">
                    </el-table-column>
                    <el-table-column prop="productName"
                                     label="产品名称">
                    </el-table-column>
                    <el-table-column prop="amount"
                                     header-align="center"
                                     align="right"
                                     label="数量"
                                     width="204">
                    </el-table-column>
                    <el-table-column prop="price"
                                     header-align="center"
                                     align="right"
                                     label="单价">
                    </el-table-column>

                    <el-table-column prop="money"
                                     header-align="center"
                                     align="right"
                                     label="金额"
                                     width="204">
                    </el-table-column>
                  </el-table>
                  <el-pagination background
                                 layout="prev, pager, next"
                                 :page-size="pageSize"
                                 :total="totalDetail"
                                 @current-change="currentDetailChange">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 导出弹框 start -->
    <ModalTips class="label-tips"
               :dialogVisible="centerDialogVisible"
               :isFooter="false">
      <div slot="content">
        <el-progress class="exportProgress"
                     :text-inside="false"
                     :show-text="false"
                     :stroke-width="16"
                     :percentage="percentage"></el-progress>
        <p>{{percenttxt}}</p>
      </div>
    </ModalTips>
    <!-- <el-dialog class="exportDialog"
               :visible.sync="centerDialogVisible"
               width="30%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               append-to-body
               center>
      <el-progress class="exportProgress"
                   :text-inside="false"
                   :show-text="false"
                   :stroke-width="16"
                   :percentage="percentage"></el-progress>
      <p>{{percenttxt}}</p>
    </el-dialog> -->
    <!-- 导出弹框 end -->
    <!-- 导出弹框 start -->
    <ModalTips class="label-tips"
               :dialogVisible="exportDialogVisible"
               @close-modal="handleExportData">
      <div slot="content">
        <el-radio-group v-model="isExportAll">
          <el-radio :label="false">当前页</el-radio>
          <el-radio :label="true">全部</el-radio>
        </el-radio-group>
      </div>
    </ModalTips>
    <!-- <el-dialog class="exportTip"
               title="导出范围"
               :visible.sync="exportDialogVisible"
               width="30%"
               append-to-body>
      <el-radio-group v-model="isExportAll">
        <el-radio :label="false">当前页</el-radio>
        <el-radio :label="true">全部</el-radio>
      </el-radio-group>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="handleExportData">确 定</el-button>
      </span>
    </el-dialog> -->
    <!-- 导出弹框 end -->
  </div>
</template>
<script>
import common from "@/libs/common";
import { MessageBox } from "element-ui";
import ModalTips from "@/components/modal/modalTips";
import {
  localToken
} from '@/libs/util';
let loading;
export default {
  name: "detailReport",
  props: {
    isModalOld: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ModalTips
  },
  data () {
    return {
      staffID: 'all',
      staffList: [{ id: 'all', name: '全部' }],
      timeDate: 1,
      timeDateValue: null,
      tableDataSummary: [],
      tableDataDetail: [],
      activeName: 'first',
      pageSize: 20,
      pageIndexSummary: 0,
      pageIndexDetail: 0,
      totalSummary: 0,
      totalDetail: 0,
      height: $("#staff-body").height() - 80,
      heightTemplate: $("#template-id").height(),
      heightStaff: $("#staff-id").height(),
      currentDate: null, // 日期
      currentAmount: 0, // 总数量
      currentMoney: 0, // 总金额
      exportDialogVisible: false,
      isExportAll: false,
      // 导出
      centerDialogVisible: false,
      percentage: 0,
      percenttxt: "导出数据100条,已处理50条,正在导出,请稍等",
      exportData: [],
      tHeaderSummary: common.tHeaderSummary,
      filterValSummary: common.filterValSummary,
      tHeaderDetail: common.tHeaderDetail,
      filterValDetail: common.filterValDetail,
      isModal: false
    }
  },
  methods: {
    // 斑马线
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    //定义导出Excel表格事件
    exportExcel (val) {
      let that = this;
      let len = 0
      // 汇总
      if (val == 0) {
        len = that.tableDataSummary.length
      } else {
        // 明细
        len = that.tableDataDetail.length
      }
      if (len == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查找数据！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      that.exportDialogVisible = true
    },
    handleExportData (val) {
      if (val) {
        let that = this
        let filterVal = []
        let tHeader = []
        let title = ""
        var dataExport = []
        // 门店预警详情导出
        let activeName = that.activeName
        // 汇总 
        if (activeName == 'first') {
          tHeader = JSON.parse(JSON.stringify(that.tHeaderSummary))
          filterVal = JSON.parse(JSON.stringify(that.filterValSummary))
          title = "单据汇总"
          // 导出全部 把要导出的数据tableData存到list
          if (that.isExportAll) {
            that.getAllStrategyTableData(0).then(res => {
              if (res) {
                dataExport = JSON.parse(JSON.stringify(res))
                that.exportDataFun(filterVal, tHeader, dataExport, title)
              }
            })
          } else {
            // 导出当前页面
            dataExport = JSON.parse(JSON.stringify(that.tableDataSummary))
            that.exportDataFun(filterVal, tHeader, dataExport, title)
          }
          that.exportDialogVisible = false
        } else {
          // 明细
          tHeader = JSON.parse(JSON.stringify(that.tHeaderDetail))
          filterVal = JSON.parse(JSON.stringify(that.filterValDetail))
          title = "单据明细"
          // 导出全部 把要导出的数据tableData存到list
          if (that.isExportAll) {
            that.getAllStrategyTableData(1).then(res => {
              if (res) {
                dataExport = JSON.parse(JSON.stringify(res))
                that.exportDataFun(filterVal, tHeader, dataExport, title)
              }
            })
          } else {
            // 导出当前页面
            dataExport = JSON.parse(JSON.stringify(that.tableDataDetail))
            that.exportDataFun(filterVal, tHeader, dataExport, title)
          }
          that.exportDialogVisible = false
        }
      } else {
        this.exportDialogVisible = false
      }
    },
    // 公用导出
    exportDataFun (filterVal, tHeader, dataExport, title) {
      let that = this
      that.centerDialogVisible = true;
      var iSpeed = 1;
      that.percentage = 0;
      that.percenttxt =
        "导出数据" + dataExport.length + "条，已处理0条，正在导出,请稍等";
      var obj = setInterval(function () {
        iSpeed += 6;
        if (iSpeed >= 100) {
          // 设置达到多少进度后停止
          that.percentage = 100;
          that.percenttxt = "导出数据" + dataExport.length + "条，已完成！";
          clearInterval(obj);
          setTimeout(() => {
            that.centerDialogVisible = false;
          }, 200);
        } else {
          that.percentage = iSpeed;
          that.percenttxt =
            "导出数据" +
            dataExport.length +
            "条，已处理" +
            parseInt(dataExport.length * (iSpeed / 100)) +
            "条，正在导出，请稍等";
        }
      }, 12); // 20毫秒后函数执行一次
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/Excel/Export2Excel');//注意这个Export2Excel路径
        const data = localToken.formatJson(filterVal, dataExport);
        export_json_to_excel(tHeader, data, title + common.getDateDetail());//最后一个是表名字
      })
    },
    getParams () {
      let that = this
      let date = null
      if (that.timeDate == 1) {
        date = common.getDateTime(new Date())
      } else if (that.timeDate == 2) {
        date = common.getPerDate()
      } else {
        // 其他日期
        if (!that.timeDateValue) {
          that.$message({
            showClose: true,
            duration: 800,
            message: "请选择日期!",
            center: true,
            type: "error"
          });
          return
        }
        date = common.getDateTime(that.timeDateValue)
      }
      let data = {
        BeginDate: date + ' 00:00:00',
        EndDate: date + ' 23:59:59',
        PageSize: that.pageSize,
      }
      // 判断是否全部完工人
      if (that.staffID != 'all') {
        data['StaffId'] = that.staffID
      }
      return data
    },
    getAllStrategyTableData (val) {
      let that = this
      let data = that.getParams()
      let totalPages = val == 0 ? that.totalSummary : that.totalDetail
      let exportTableData = []
      let promiseArr = []
      promiseArr = Array.apply(null, Array(totalPages)).map(function (
        item,
        index
      ) {
        data['PageIndex'] = index
        return new Promise((resolve, reject) => {
          // 汇总
          if (val == 0) {
            common.getReportSummary(data).then(res => {
              let tableData = res.items.map(item => {
                item['date'] = common.getDateTime(item['date'])
                return item
              })
              exportTableData = exportTableData.concat(tableData)
              resolve(tableData)
            },
              err => {
                reject(err)
              }
            )
          } else {
            // 明细
            common.getReportDetail(data).then(res => {
              // 新增table合并
              let tableData = []
              res.items.map((item, index) => {
                item['date'] = common.getDateTime(item['date'])
                // table合并数据转化
                item.products.map((option, indexOpt) => {
                  let obj = JSON.parse(JSON.stringify(item))
                  obj['productCode'] = option.productCode //编码
                  obj['productName'] = option.productName //商品
                  obj['price'] = option.price //单价
                  obj['amount'] = option.amount //数量
                  obj['money'] = common.toDecimal3(option.money) //金额
                  tableData.push(obj)
                })
              });
              exportTableData = exportTableData.concat(tableData)
              resolve(tableData)
            },
              err => {
                reject(err)
              }
            )
          }
        })
      })
      return new Promise((resolve, reject) => {
        Promise.all(promiseArr).then(
          res => {
            let len = promiseArr.length
            resolve(len === totalPages ? exportTableData : null)
          },
          err => {
            reject(err)
          }
        )
      })
    },
    tabClick () {
      let that = this
      that.pageIndexSummary = 0
      that.pageIndexDetail = 0
      that.getData()
    },
    // 改变页码 
    currentSummaryChange (val) {
      let that = this
      that.pageIndexSummary = val - 1
      that.getData()
    },
    // 改变页码
    currentDetailChange (val) {
      let that = this
      that.pageIndexDetail = val - 1
      that.getData()
    },
    // 合并表格方法
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (row.handleSpanIndex > 1 && columnIndex < row.handleSpanColumn && columnIndex > 0) {
        return {
          rowspan: row.handleSpanIndex,
          colspan: 1
        };
      }
      if (!row.handleSpanIndex && columnIndex < row.handleSpanColumn && columnIndex > 0) {
        return {
          rowspan: 0,
          colspan: 0
        };
      }
    },
    // 获取页面显示数据
    getData () {
      let that = this
      let activeName = that.activeName
      let date = null
      if (that.timeDate == 1) {
        date = common.getDateTime(new Date())
      } else if (that.timeDate == 2) {
        date = common.getPerDate()
      } else {
        // 其他日期
        if (!that.timeDateValue) {
          that.$message({
            showClose: true,
            duration: 800,
            message: "请选择日期!",
            center: true,
            type: "error"
          });
          return
        }
        date = common.getDateTime(that.timeDateValue)
      }
      loading = that.$loading({
        lock: true,
        text: "拼命加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      let data = {
        BeginDate: date + ' 00:00:00',
        EndDate: date + ' 23:59:59',
        PageSize: that.pageSize,
      }
      // 判断是否全部完工人
      if (that.staffID != 'all') {
        data['StaffId'] = that.staffID
      }
      // 汇总
      if (activeName == 'first') {
        data['PageIndex'] = that.pageIndexSummary
        common.getReportSummary(data).then(res => {
          setTimeout(loading.close(), 500)
          that.currentDate = date // 日期
          that.currentAmount = common.toDecimal3(res.amount) // 总数量
          that.currentMoney = common.toDecimal3(res.money) // 总金额
          that.totalSummary = res.totalCount
          that.tableDataSummary = res.items.map(item => {
            item['date'] = common.getDateTime(item['date'])
            item['money'] = common.toDecimal3(item.money) //金额
            return item
          })
        },
          err => {
            setTimeout(loading.close(), 500)
            console.log(err)
          }
        )
      } else {
        // 明细
        data['PageIndex'] = that.pageIndexDetail
        common.getReportDetail(data).then(res => {
          setTimeout(loading.close(), 500)
          that.tableDataDetail = res.items
          // 新增table合并
          let tableData = []
          res.items.map((item, index) => {
            item['date'] = common.getDateDetail2(item['updateDate'])
            // table合并数据转化
            item.products.map((option, indexOpt) => {
              let obj = JSON.parse(JSON.stringify(item))
              obj['handleSpanIndex'] = indexOpt == 0 ? item.products.length : 0 //金额
              obj['handleSpanColumn'] = 3
              obj['productCode'] = option.productCode //编码
              obj['productName'] = option.productName //商品
              obj['price'] = option.price //单价
              obj['amount'] = option.amount //数量
              obj['money'] = common.toDecimal3(option.money) //金额
              tableData.push(obj)
            })
          });
          that.tableDataDetail = tableData
          that.totalDetail = res.totalCount
          that.currentDate = date // 日期
          that.currentAmount = common.toDecimal3(res.amount) // 总数量
          that.currentMoney = common.toDecimal3(res.money) // 总金额
        },
          err => {
            setTimeout(loading.close(), 500)
            console.log(err)
          }
        )
      }
    },
    // 更换日期
    changeTimeDate (val) {
      let that = this
      if (val != 3) {
        that.getData()
      } else {
        that.timeDateValue = null
      }
    },
    // 返回上一个页面
    goBack () { this.$router.go(-1); },
    // 初始化
    init () {
      let that = this
      loading = that.$loading({
        lock: true,
        text: "拼命加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      Promise.all([common.getStaff()])
        .then(
          res => {
            // 完工人
            if (res[0] && res[0].length > 0) {
              // that.staffID = res[0][0].id
              that.staffList = [{ id: 'all', name: '全部' }].concat(res[0])
            }
            loading.close();
            that.getData()
            that.$nextTick(() => {
              that.height = $("#staff-body").height() - 80;
              that.heightTemplate = $("#template-id").height();
              that.heightStaff = $("#staff-id").height();
            });
          },
          err => {
            that.$nextTick(() => {
              loading.close();
            });
          }
        )
        .catch(err => {
          that.$nextTick(() => {
            loading.close();
          });
        });
    }
  },
  mounted () {
    this.init()
  },
  // 监听模态框，记录当前页面是否有模态框弹出
  watch: {
    isModalOld (newval, val) {
      this.isModal = newval
    },
    centerDialogVisible (newval, val) {
      this.isModal = newval
    },
    exportDialogVisible (newval, val) {
      this.isModal = newval
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/main/detailReport.vue